module.exports = __webpack_public_path__ + "img/foot-link1.0e738271.png";